import Vue from 'vue';

import ValidatedField from './ValidatedField.vue';
import SlimSelect from './SlimSelect.vue';
import CheckBox from './CheckBox.vue';
import Switcher from './Switcher.vue';
import Radio from './Radio.vue';
import SubmitButton from './SubmitButton.vue';
import DropDown from './DropDown.vue';
import DatePicker from './DatePicker.vue';
import Spinner from './Spinner.vue';
import LangSelector from './LangSelector.vue';
import Floater from './Floater.vue';
import Tabs from './Tabs.vue';
import SearchFilter from './SearchFilter.vue';
import SortIndicator from './SortIndicator.vue';
import Pagination from './Pagination.vue';
import Breadcrumb from './Breadcrumb.vue';
import Icon from './Icon.vue';
import RichTextEditor from './RichTextEditor.vue';

Vue.component(ValidatedField.name, ValidatedField);
Vue.component(SlimSelect.name, SlimSelect);
Vue.component(CheckBox.name, CheckBox);
Vue.component(Switcher.name, Switcher);
Vue.component(Radio.name, Radio);
Vue.component(SubmitButton.name, SubmitButton);
Vue.component(DropDown.name, DropDown);
Vue.component(DatePicker.name, DatePicker);
Vue.component(Spinner.name, Spinner);
Vue.component(LangSelector.name, LangSelector);
Vue.component(Floater.name, Floater);
Vue.component(Tabs.name, Tabs);
Vue.component(SearchFilter.name, SearchFilter);
Vue.component(SortIndicator.name, SortIndicator);
Vue.component(Pagination.name, Pagination);
Vue.component(Breadcrumb.name, Breadcrumb);
Vue.component(Icon.name, Icon);
Vue.component(RichTextEditor.name, RichTextEditor);
